import { jsx as _jsx } from "react/jsx-runtime";
import ReviewModal from '../../../ReviewForm/ReviewModal';
export const ReviewFormModal = (props)=>{
    const { onSuccess } = props;
    return /*#__PURE__*/ _jsx(ReviewModal, {
        showModal: true,
        closeModalFunc: onSuccess
    });
};
